
import _ from 'lodash';
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
	name: 'ChatLogin',
	data () {
		return {
			// username: 'koon wai',
			// email: 'kwaik@yahoo.com',
			username: '',
			email: '',
		}
	},
	computed: {
		...mapState({
			pageName: state => state.chatapp.pageName,
		})
	},
	mounted() {

	},
	methods: {
		...mapActions({
			saveUserData: 'chatapp/saveUserData'
		}),
		...mapMutations({
			setPageName: 'chatapp/setPageName',

			setSelectedRoom: 'chatapp/setSelectedRoom',
			setRoomList: 'chatapp/setRoomList',
			setMessageList: 'chatapp/setMessageList',
		}),
		async clickButton() {
			const email = _.trim(this.email);
			const name = _.trim(this.username);
			if (email == '' || name == '') {
				console.log('fields is require');
				return;
			}
			// 1. LOGIN
			this.$socket.emit('login', {email, name}, (res) => {
				console.log('CB login', res);
				this.saveUserData(res.item);
				const clientCid = res.item.cid;
				// 2. LOAD ROOM LIST
				this.$socket.emit('getRoomList', {clientCid}, (data) => {
					console.log('CB getRoomList', data);
					this.setRoomList(data.items);
				});
				this.setPageName('/MESSAGE');
			});
		},
	},
}
